import { StackShim as Stack, StackItemShim as StackItem } from '@fluentui/react-migration-v8-v9';
import { Label, makeStyles } from '@fluentui/react-components';
import {
  PersonAddRegular,
  ClipboardTaskRegular,
  ChatRegular,
  PersonSwapRegular,
} from '@fluentui/react-icons';
import React from 'react';
import moment from 'moment';
import ActivityItem from '../../../common/ActivityItem';
import StatDateFormats from '../../../../utils/types/DateFormats';
import {
  AgmTrackerItemActionType,
  IAgmTrackerAction,
} from '../../annualFilingRequirements/IAgmListPageSearchResult';

interface IAgmTrackerItemHistoryProps {
  actionItems: IAgmTrackerAction[];
}

const useStyles = makeStyles({
  activityItem: {
    marginTop: '10px',
  },
  historyStack: {
    marginBottom: '20px',
  },
  stickyHeader: {
    position: 'sticky',
    top: '0',
    zIndex: 10,
    backgroundColor: 'white',
    paddingBottom: '10px',
  },
});

const AgmTrackerItemHistory = ({ actionItems }: IAgmTrackerItemHistoryProps): JSX.Element => {
  const styles = useStyles();
  const renderActivityItem = (item: IAgmTrackerAction): JSX.Element => {
    const user = item.changedBy?.displayName;
    let description = '';
    let comments = '';
    let activityIcon: JSX.Element;

    switch (item.actionType) {
      case AgmTrackerItemActionType.CelaAssigneeChange:
        activityIcon = <PersonAddRegular />;
        description = `${user} updated CELA assignees to:`;
        comments = item.actionValue ?? 'No assignees';
        break;
      case AgmTrackerItemActionType.StatusChange:
        activityIcon = <ClipboardTaskRegular />;
        description = `${user} updated the status to "${item.actionValue}" with comments:`;
        comments = item.comments;
        break;
      case AgmTrackerItemActionType.Comment:
        activityIcon = <ChatRegular />;
        description = `${user} commented:`;
        comments = item.comments;
        break;
      case AgmTrackerItemActionType.OwnerChange:
        activityIcon = <PersonSwapRegular />;
        description = `${user} updated owner to "${item.actionValue}" with comments:`;
        comments = item.comments;
        break;
      case AgmTrackerItemActionType.OwnerChangeBySystem:
        activityIcon = <PersonSwapRegular />;
        description = `Owner changed to "${item.actionValue}":`;
        comments = item.comments;
        break;
      default:
        activityIcon = <ClipboardTaskRegular />;
        description = '';
    }
    return (
      <ActivityItem
        key={item.id}
        timeStamp={moment(item.actionDate).format(StatDateFormats.DayWithTime)}
        activityDescription={description}
        className={styles.activityItem}
        activityIcon={activityIcon}
        comments={comments}
      />
    );
  };

  return (
    <Stack className={styles.historyStack}>
      <div className={styles.stickyHeader}>
        <Label>History</Label>
      </div>
      <StackItem>
        {actionItems?.length === 0 && <span>No history available.</span>}
        {actionItems?.map((item: IAgmTrackerAction) => {
          return renderActivityItem(item);
        })}
      </StackItem>
    </Stack>
  );
};

export default AgmTrackerItemHistory;
